import { useTranslation } from 'react-i18next';
import { getImageUrl } from '../utils/imageUtils';

const UseCases = () => {
  const { t } = useTranslation();

  const useCases = [
    {
      icon: '🏋️‍♀️',
      title: t('use_cases.gym')
    },
    {
      icon: '🏢',
      title: t('use_cases.office')
    },
    {
      icon: '🏘️',
      title: t('use_cases.residential')
    },
    {
      icon: '🏭',
      title: t('use_cases.warehouse')
    }
  ];

  return (
    <section id="use" className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2 items-center">
          <div>
            <h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">
              {t('use_cases.title')}
            </h2>
            <p className="mt-4 text-lg text-slate-600">
              {t('use_cases.subtitle')}
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {useCases.map((useCase, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="text-2xl">{useCase.icon}</div>
                  <div className="text-sm font-medium text-slate-900">{useCase.title}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img 
              src={getImageUrl("/images/smart-pantry-angle.png")} 
              alt="Sleek black Tap'nGrab smart cooler for modern office and commercial spaces"
              className="w-full h-auto rounded-[2rem] chip"
            />
            
            {/* Floating overlay - desktop only */}
            <div className="absolute -top-6 -left-6 hidden sm:block bg-white/80 p-3 rounded-2xl border chip">
              <img 
                src={getImageUrl("/images/wood-smart-pantry-angle.png")} 
                alt="Wood finish variant" 
                className="w-48 h-auto rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCases;
